import { gql } from '@apollo/client'

export const SET_TOP_PERCENTAGE_FOR_COMPANY_COUNTRY = gql`
  mutation SetTopPercentageForCompanyCountry($companyId: HashedId!, $country: String!, $topPercentage: Float!) {
    setTopPercentageForCompanyCountry(companyId: $companyId, country: $country, topPercentage: $topPercentage)
  }
`
export const SET_LOW_PERCENTAGE_FOR_COMPANY_COUNTRY = gql`
  mutation SetLowPercentageForCompanyCountry($companyId: HashedId!, $country: String!, $lowPercentage: Float!) {
    setLowPercentageForCompanyCountry(companyId: $companyId, country: $country, lowPercentage: $lowPercentage)
  }
`
export const SET_LOW_PERCENTAGE_IS_BLOCKER_FOR_COMPANY_COUNTRY = gql`
  mutation SetLowPercentageIsBlockerForCompanyCountry($companyId: HashedId!, $country: String!, $lowPercentageIsBlocker: Boolean!) {
    setLowPercentageIsBlockerForCompanyCountry(companyId: $companyId, country: $country, lowPercentageIsBlocker: $lowPercentageIsBlocker)
  }
`
export const SET_DISABLE_RANKING_FOR_COMPANY_COUNTRY = gql`
  mutation SetDisableRankingForCompanyCountry($companyId: HashedId!, $country: String!, $isDisabled: Boolean!) {
    setDisableRankingForCompanyCountry(companyId: $companyId, country: $country, isDisabled: $isDisabled)
  }
`
export const SET_IS_TAG_ASSIGNMENT_IN_PROGRESS_FOR_COMPANY_COUNRTY = gql`
  mutation SetIsTagAssignmentInProgressForCompanyCountry($companyId: HashedId!, $country: String!, $isEnabled: Boolean!) {
    setIsTagAssignmentInProgressForCompanyCountry(companyId: $companyId, country: $country, isEnabled: $isEnabled)
  }
`

export const CONFIRM_TAG_ASSIGNMENT_FOR_COMPANY_COUNTRY = gql`
  mutation ConfirmTagAssignmentForCompanyCountry($companyId: HashedId!, $country: String!) {
    confirmTagAssignmentForCompanyCountry(companyId: $companyId, country: $country)
  }
`
